export default __webpack_public_path__ + "static/media/email.f71af6a6.svg";